import { Component, inject } from '@angular/core';
import { UflaUser } from '../../service/auth/ufla-user';
import { Aufgabe } from '../../domain/model/aufgabe';
import { ActivatedRoute } from '@angular/router';
import { AufgabeDialogService } from '../aufgabe-dialog.service';
import { AuthenticationService } from '../../service/auth/authentication.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'ufla-aufgaben-dashboard',
    templateUrl: './aufgaben-dashboard.component.html',
    styleUrls: [
        './aufgaben-dashboard.component.scss',
    ],
    standalone: false,
})
export class AufgabenDashboardComponent {
    private route = inject(ActivatedRoute);
    private aufgabeDialogService = inject(AufgabeDialogService);
    authenticationService = inject(AuthenticationService);
    dialog = inject(MatDialog);


    public uflaUser: UflaUser;
    public aufgabe: Aufgabe;

    constructor() {
        this.uflaUser = this.route.snapshot.data.profile;
    }

    public openErstelleVorgangDialog() {
        this.aufgabeDialogService.openDetail();
    }

    public openCreateGesamtlastOrAbwurfpunkteDialog() {
        this.aufgabeDialogService.openGesamtlastOrAbwurfpunkteDetail();
    }

    canCreateVorgang() {
        return this.authenticationService.isAdmin(this.uflaUser) || this.authenticationService.isUenb(this.uflaUser);
    }

    canCreateGesamtlastOrAbwurfpunkteVorgang() {
        return this.authenticationService.isVnbAdmin(this.uflaUser);
    }


}
